import { render, staticRenderFns } from "./tagProList.vue?vue&type=template&id=3899a8eb&"
import script from "./tagProList.vue?vue&type=script&lang=js&"
export * from "./tagProList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports